<template>
  <div class="hero-section">
    <ShopDefaultHeroSection v-if="heroSectionToShow === 'default'" />
    <PremiumMonthlyPromoSection v-if="heroSectionToShow === 'premium-monthly'" />
    <EDAPremiumPreSaleSection v-if="heroSectionToShow === 'eeda-presale'" />
    <BooGoHeroSection v-if="heroSectionToShow === 'boogo'" />
    <BlackFridayHeroSection v-if="heroSectionToShow === 'black-friday'" />
    <eCPPTPreSaleSection v-if="heroSectionToShow === 'ecppt-presale'" />
    <LeapYearHeroSection v-if="heroSectionToShow === 'leap-year-2024'" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PremiumMonthlyPromoSection from '@/components/hero-sections/PremiumMonthlyPromoSection.vue'
import EDAPremiumPreSaleSection from '@/components/hero-sections/EDAPremiumPreSaleSection.vue'
import ShopDefaultHeroSection from '@/components/hero-sections/ShopDefaultHeroSection.vue'
import BooGoHeroSection from '@/components/hero-sections/BooGoHeroSection.vue'
import BlackFridayHeroSection from '@/components/hero-sections/BlackFridayHeroSection.vue'
import LeapYearHeroSection from '@/components/hero-sections/LeapYearHeroSection.vue'
import { routesRules } from '@/helpers/mixins'
import eCPPTPreSaleSection from '@/components/hero-sections/eCPPTPreSaleSection.vue'

export default {
  name: 'HeroSection',
  emits: ['hero-section-to-show'],
  mixins: [routesRules],
  components: {
    PremiumMonthlyPromoSection,
    EDAPremiumPreSaleSection,
    eCPPTPreSaleSection,
    ShopDefaultHeroSection,
    BooGoHeroSection,
    BlackFridayHeroSection,
    LeapYearHeroSection,
  },
  data() {
    return {
      heroSectionToShow: 'default',
    }
  },
  computed: {
    ...mapState({
      isOnePlanAvailable: state => state.products.isOnePlanAvailable,
      showGenericBackground: state => state.app.showGenericBackground,
      isPremiumMonthlyPromoActive: state => state.app.isPremiumMonthlyPromoActive,
      isEDAPremiumPreSaleActive: state => state.app.isEDAPremiumPreSaleActive,
      isAuthenticated: state => state.auth.isAuthenticated,
      usersCurrentSubscriptions: state => state.subscriptions.usersCurrentSubscriptions,
      userHasSkillDive: state => state.subscriptions.userHasSkillDive,
    }),
    ...mapGetters({
      isBooGoPromoActive: 'app/getIsBooGoPromoActive',
      isBlackFridayActive: 'app/isBlackFridayActive',
      isPreSaleActive: 'app/getRunningPreSale',
      isLeapYearPromoActive: 'app/isLeapYearPromoActive',
      isBusinessUser: 'business/isBusinessUser',
    }),
    heroSectionToggler() {
      return [
        {
          name: 'eeda-presale',
          validation: [
            !this.isOnePlanAvailable,
            this.isEDAPremiumPreSaleActive,
            this.isShopPage || this.isEDAPremiumPage,
          ],
        },
        {
          name: 'premium-monthly',
          validation: [
            !this.isOnePlanAvailable,
            this.isPremiumMonthlyPromoActive,
            this.isShopPage || this.isPremiumMonthlyPromoPage,
          ],
        },
        {
          name: 'boogo',
          validation: [
            [
              !this.isAuthenticated,
              !this.isOnePlanAvailable,
              this.isBooGoPromoActive,
              this.isShopPage || this.isBooGoPage,
            ],
            [
              this.isAuthenticated,
              !this.isOnePlanAvailable,
              this.isBooGoPromoActive,
              !(this.usersCurrentSubscriptions.length > 0),
              this.userHasSkillDive,
              this.isShopPage || this.isBooGoPage,
            ],
          ],
        },
        {
          name: 'black-friday',
          validation: [
            !this.isBusinessUser,
            !this.isOnePlanAvailable,
            this.isBlackFridayActive,
            this.isShopPage || this.isBlackFridayPage,
          ],
        },
        {
          name: 'leap-year-2024',
          validation: [
            !this.isOnePlanAvailable,
            this.isLeapYearPromoActive,
            this.isShopPage || this.isLeapYearPromoPage,
          ],
        },
        {
          name: 'ecppt-presale',
          validation: [!this.isAuthenticated, this.isPreSaleActive],
        },
        {
          name: 'default',
          validation: [this.showGenericBackground],
        },
      ]
    },
  },
  methods: {
    setHeroSectionToShow() {
      const heroHeaderValue = this.heroSectionToggler.find(heroHeader => {
        if (heroHeader.validation[0].length > 1) {
          const validations = heroHeader.validation.find(validationsBlock =>
            validationsBlock.every(v => v === true)
          )
          return !!validations
        }
        return heroHeader.validation.every(v => v === true)
      })
      const heroHeaderOutput = heroHeaderValue ? heroHeaderValue.name : 'default'
      return !this.isShopPage ? '' : heroHeaderOutput
    },
  },
  created() {
    this.heroSectionToShow = this.setHeroSectionToShow()
    this.$emit('hero-section-to-show', this.heroSectionToShow)
  },
  unmount() {
    this.heroSectionToShow = ''
    this.$emit('hero-section-to-show', '')
  },
}
</script>

<style lang="scss" scoped>
.hero-section {
  display: block;
}
</style>
